import { gql } from '@apollo/client';

export const ASSIGN_TEAM_MEMBER = gql`
  mutation AssignTeamRoleToTeamMember(
    $request: AssignTeamRoleToTeamMemberRequest!
  ) {
    AssignTeamRoleToTeamMember(request: $request) {
      id
    }
  }
`;

export const ADD_MULTIPLE_TEAM_MEMBER = gql`
  mutation AddMultipleTeamMember($request: AddMultipleTeamMemberRequest!) {
    AddMultipleTeamMember(request: $request) {
      ... on TeamMembers {
        data {
          id
          team {
            ... on Team {
              id
              name
            }
          }
          user {
            ... on User {
              id
              name
            }
          }
          role {
            ... on Role {
              id
              slug
              name
            }
          }
        }
      }
    }
  }
`;
export const ADD_MULTIPLE_TEAM_MEMBER_FOR_USER = gql`
  mutation AddMultipleTeamMemberForTeamMember(
    $request: AddMultipleTeamMemberRequest!
  ) {
    AddMultipleTeamMemberForTeamMember(request: $request) {
      ... on TeamMembers {
        data {
          id
          team {
            ... on Team {
              id
              name
            }
          }
          user {
            ... on User {
              id
              name
            }
          }
          role {
            ... on Role {
              id
              slug
              name
            }
          }
        }
      }
    }
  }
`;

export const REMOVE_TEAM_MEMBER = gql`
  mutation RemoveUserFromTeam($team_id: String!, $user_id: String!) {
    RemoveUserFromTeam(team_id: $team_id, user_id: $user_id)
  }
`;

export const REMOVE_USER_FROM_TEAM_FOR_TEAM_MEMBER = gql`
  mutation RemoveUserFromTeamForTeamMember(
    $team_id: String!
    $user_id: String!
  ) {
    RemoveUserFromTeamForTeamMember(team_id: $team_id, user_id: $user_id)
  }
`;

export const REPLACE_TEAM_ROLE_OF_USER = gql`
  mutation ReplaceTeamRoleOfUser($request: ReplaceTeamRoleOfUserRequest!) {
    ReplaceTeamRoleOfUser(request: $request) {
      id
      team_id
      user_id
      role_id
      role {
        ... on Role {
          id
          slug
          description
        }
      }
      type
      user {
        ... on User {
          roles {
            ... on Roles {
              data {
                id
                slug
                created_at
                updated_at
                deleted_at
              }
            }
          }
        }
      }
    }
  }
`;
